import { Message } from "Models/message";
import { Partition } from "Models/partition";
import { addLogMessage, setLog } from "Redux/actions";
import { getLog as getLogState } from "Redux/selectors";
import store, { dispatch } from "Redux/store";
import { getAllConsumers } from "./consumers.service";
import { getActiveLeads, getAllPartitions } from "./partitions.service";
import { v4 as uuidv4 } from "uuid";

export const getLog = (uid: string) => getLogState(store.getState(), uid);

export const getActiveLeadLog = (id: number) => {
    const lead = getActiveLeads(getAllPartitions()).find((p) => p.id === id);
    return lead ? getLog(lead.logUid) : [];
};

export const getPartitionLogs = (): Message[][] =>
    getAllPartitions().map((p) => getLog(p.logUid));

export const addMessage = (logUid: string, msg: Message): Message => {
    const { uid: originUid } = msg;
    const uid = uuidv4();
    const newMessage = { ...msg, uid, originUid };
    dispatch(addLogMessage(logUid, newMessage));
    return newMessage;
};

export const getConsumerLogs = (): Message[][] =>
    getAllConsumers()
        .flatMap((c) => c.leads)
        .map((id) => getActiveLeadLog(id));

export const createLogs = (partitions: Partition[]) => {
    partitions.forEach((p) => dispatch(setLog(p.logUid, getLog(p.logUid))));
};

export const syncLogs = (uidTarget: string, uidSource: string) => {
    const currentTargetLog = getLog(uidTarget);
    const targetLog = getLog(uidSource).map((m) => {
        const existing = currentTargetLog.find(({ id }) => id === m.id);

        return (
            existing || {
                ...m,
                originUid: m.uid,
                uid: uuidv4(),
            }
        );
    });
    dispatch(setLog(uidTarget, targetLog));
};
